import { useParams } from 'react-router';

interface DebriefParams {
    tracklogId?: string;
    shareId?: string;
    [otherParams: string]: string; // It bothers me that this is required
}

export function useDebriefRouter() {
    const params = useParams<DebriefParams>();

    const getTracklogListRouteString = (): string => {
        return `/`;
    };

    const getTracklogRouteString = (tracklogId: string): string => {
        if (!tracklogId) return null;
        return `/${tracklogId}`;
    };

    const getDebriefRouteString = (tracklogId: string): string => {
        if (!tracklogId) return null;
        return `/${tracklogId}/debrief`;
    };

    const getSharedRouteString = (shareId: string): string => {
        if (!shareId) return null;
        return `/shared/${shareId}`;
    };

    const getSharedDebriefRouteString = (shareId: string): string => {
        if (!shareId) return null;
        return `/${shareId}/debrief/shared`;
    };

    return {
        routeParams: params,
        getTracklogListRouteString,
        getTracklogRouteString,
        getDebriefRouteString,
        getSharedDebriefRouteString,
        getSharedRouteString,
    };
}

export default useDebriefRouter;
